'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getActiveLanguage } from 'DesignData/selectors/statusBar';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StatusBarSection from 'DesignComponents/statusBar/StatusBarSection';
import { languageI18nKey } from 'DesignComponents/utils/I18nKeys';

const i18nKey = key => `DesignEditorsUI.statusBar.${key}`;

class StatusBarLanguage extends PureComponent {
  render() {
    const {
      activeLanguage
    } = this.props;
    if (!activeLanguage) return null;

    const language = /*#__PURE__*/_jsx(FormattedMessage, {
      message: languageI18nKey(activeLanguage)
    });

    const typeLabel = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: i18nKey('typeGroup.translations'),
      options: {
        language
      }
    });

    return /*#__PURE__*/_jsx(StatusBarSection, {
      label: typeLabel
    }, "language-editor-sublocation");
  }

}

StatusBarLanguage.propTypes = {
  activeLanguage: PropTypes.string
};

const mapStateToProps = state => {
  const activeLanguage = getActiveLanguage(state);
  return {
    activeLanguage
  };
};

export default connect(mapStateToProps, null)(StatusBarLanguage);